export default "__VITE_ASSET__BTpuFqSO__"